import Service from '../Service';
import { addFingerprintToRequest } from './utils';
import Request from '../Request';
import { ResponseErrorBody, RequestParamsMonolith } from '../../types';

export default async function(params: RequestParamsMonolith) {
  const request = await addFingerprintToRequest(
    new Request<RequestParamsMonolith>('/api/auth/monolith')
      .setMethod('POST')
      .setPayload(params)
  );
  const service = new Service<any, ResponseErrorBody>(request);
  return await service.send();
}
